import React, { useState } from "react";
import Button from "@mui/material/Button";
import ReactDOM from "react-dom";

const EditIcon = () => (
    <svg
        className="edit-svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ width: 16, height: 16, strokeWidth: 2.2 }}
    >
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <g className="pen">
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </g>
    </svg>
);

const baseStyles = {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 14,
    fontWeight: 500,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    borderRadius: "5px",
    textTransform: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    "& .MuiButton-startIcon": { margin: 0 },
    "&:hover .pen": {
        animation: "wiggle 1.4s ease-in-out infinite",
        transformOrigin: "18px 6px",
    },
};

const variantStyles = {
    filled: {
        variant: "contained",
        sx: {
            backgroundColor: "#5177B8",
            color: "#fff",
            boxShadow: "none",
            border: "none",
            "&:hover": { backgroundColor: "#2F4874", boxShadow: "none", border: "none" },
        },
    },
    outlined: {
        variant: "outlined",
        sx: {
            color: "#5177B8",
            borderColor: "#5177B8",
            "&:hover": { borderColor: "#2F4874", color: "#2F4874" },
        },
    },
    ghost: {
        variant: "text",
        sx: {
            color: "#5177B8",
            border: "none",
            "&:hover": { color: "#2F4874", backgroundColor: "rgba(81, 119, 184, 0.08)", border: "none" },
        },
    },
};

function EditButton({ kind = "ghost", onClick, modal, children = "Rediger" }) {
    const [open, setOpen] = useState(false);
    const { variant, sx } = variantStyles[kind];

    const handleClick = () => {
        if (onClick) onClick();
        setOpen(true);
    };

    return (
        <span>
            <style>{animationStyles}</style>
            <Button
                variant={variant}
                onClick={handleClick}
                startIcon={<EditIcon />}
                sx={{ ...baseStyles, ...sx }}
            >
                {children}
            </Button>
            {modal && ReactDOM.createPortal(
                React.cloneElement(modal, {
                    open,
                    onCancel: () => setOpen(false),
                    onClose: (e, reason) => {
                        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
                        setOpen(false);
                    },
                }),
                document.body
            )}
        </span>
    );
}

export const EditButtonFilled   = (props) => <EditButton kind="filled"   {...props} />;
export const EditButtonOutlined = (props) => <EditButton kind="outlined" {...props} />;
export const EditButtonGhost    = (props) => <EditButton kind="ghost"    {...props} />;

const animationStyles = `
  @keyframes wiggle {
    0%        { transform: rotate(0deg); }
    8%        { transform: rotate(-15deg); }
    16%       { transform: rotate(12deg); }
    24%       { transform: rotate(-10deg); }
    32%       { transform: rotate(8deg); }
    40%       { transform: rotate(-5deg); }
    48%       { transform: rotate(3deg); }
    56%, 100% { transform: rotate(0deg); }
  }
`;